import React from "react";
import { Page, Text, View, Document, StyleSheet, pdf } from "@react-pdf/renderer";


// Styles
const styles = StyleSheet.create({
  page: { padding: 20, fontSize: 12 },
  title: { fontSize: 18, marginBottom: 10, textAlign: "center", fontWeight: "bold" },
  table: { width: "100%", marginTop: 10, borderTopWidth: 1, borderColor: "black" },
  row: { flexDirection: "row", borderBottomWidth: 1, borderColor: "black", padding: 5 },
  headerRow: { backgroundColor: "#333", color: "white", flexDirection: "row", padding: 8 },
  cellHeader: { flex: 1, fontWeight: "bold", textAlign: "left" },
  cell: { flex: 1, textAlign: "left" },
 

  daySection: { marginTop: 10,paddingTop: 5 },
  dayTitle: { fontSize: 14, fontWeight: "bold", textTransform: "capitalize", marginBottom: 5 },
  classSection: { marginLeft: 20, marginTop: 5 },
  classTitle: { fontSize: 12, fontWeight: "bold", marginBottom: 2 },
  productText: { fontSize: 12, marginLeft: 15 },
});

// Product PDF - dynamic data
const ProductPDF = ({ productData }) => (
  <Document>
    <Page style={styles.page}>
      <Text style={styles.title}>{productData.leverancier}</Text>
      <View style={styles.table}>
        <View style={styles.headerRow}>
          <Text style={styles.cellHeader}>Naam</Text>
          <Text style={styles.cellHeader}>Aantal</Text>
        </View>
        {productData.producten.map((item, index) => (
          <View key={index} style={styles.row}>
            <Text style={styles.cell}>{item.product}</Text>
            <Text style={styles.cell}>{item.aantal}{item.eenheid}</Text>
          </View>
        ))}
      </View>

      <View style={styles.daySection}>
      <Text style={styles.classTitle}>Opmerking:</Text>
      <Text >{productData.opmerking}</Text>
      </View>
    </Page>
  </Document>
);



const VleesPDF = ({ vleesData }) => {

  const formatDate = (dateString) => {
    const dateObj = new Date(dateString);
    return dateObj.toLocaleDateString("nl-BE", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };
  const formatDatum = (datum) => {
    
    return datum.toLocaleDateString("nl-BE", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };
  const groupedByDay = {};

  vleesData.producten.forEach((item) => {
    const date = formatDate(item.datum) // Extract YYYY-MM-DD
    const leerkracht = item.leerkracht || "Onbekend"; // Use "Onbekend" if missing
  
    if (!groupedByDay[date]) {
      groupedByDay[date] = {};
    }
  
    if (!groupedByDay[date][leerkracht]) {
      groupedByDay[date][leerkracht] = [];
    }
  
    groupedByDay[date][leerkracht].push(item);
  });
  

  return (
    <Document>
    <Page style={styles.page}>
      <Text style={styles.title}>{vleesData.leverancier}</Text>
  
      {Object.entries(groupedByDay).map(([date, leerkrachten]) => (
        <View key={date} style={styles.daySection}>
          <Text style={styles.dayTitle}>{date}</Text>
  
          {Object.entries(leerkrachten).map(([leerkracht, producten]) => (
            <View key={leerkracht} style={styles.classSection}>
              <Text style={styles.classTitle}>- Leerkracht: {leerkracht}</Text>
  
              {producten.map((item, index) => (
                <Text key={index} style={styles.productText}>
                  • {item.product}: {item.aantal} {item.eenheid} (Klas: {item.klas})
                </Text>
              ))}
            </View>
          ))}
        </View>
      ))}
      <View style={styles.daySection}>
      <Text style={styles.classTitle}>Opmerking:</Text>
      <Text >{vleesData.opmerking}</Text>
      </View>
      
    </Page>
  </Document>
  
  

  );
};




// We halen de data via props op. Deze JSON kan er bijvoorbeeld zo uitzien:
//
// {
//   dag: "donderdag",
//   datum: "2025-02-20T00:00:00.000Z",
//   klas: "211",
//   lokaal: "nog niet geimplementeerd",
//   leerkracht: "Gebruikersbeheerder",
//   producten: [
//     { product: "wortel", aantal: 6, eenheid: "stuks", locatie: "koelcel", kleur: "#a52dd2" },
//     { product: "selder", aantal: 6, eenheid: "stuks", locatie: "koelcel", kleur: "#a52dd2" }
//   ],
//   legende: [
//     { _id: "...", naam: "F8", kleur: "#3dc286" },
//     { _id: "...", naam: "koelcel", kleur: "#a52dd2" },
//     { _id: "...", naam: "Enkel leerkrachten", kleur: "#f239e9" }
//   ]
// }


const logistiekStyles = StyleSheet.create({
  page: {
    padding: 20,
    //margin: 50,
    fontSize: 12,
    fontFamily: "Helvetica",
  },
  header: {
    marginBottom: 10,
    padding: 10,
    backgroundColor: "#f2f2f2",
  },
  titleRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 2,
  },
  titleText: {
    fontWeight: "bold",
  },
  table: {
    width: "100%",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableHeader: {
    backgroundColor: "#e0e0e0",
    fontWeight: "bold",
  },
  tableCell: {
    width: "33.3%", // Drie kolommen
    textAlign: "left",
    paddingHorizontal: 4,
  },
  headerCell: {
    fontWeight: "bold",
  },
  legendContainer: {
    marginTop: 20,
    padding: 10,
    border: "1px solid #ccc",
    width: 200
  },
  legendTitle: {
    fontWeight: "bold",
    marginBottom: 5,
  },
  legendItem: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 3,
  },
  colorBox: {
    width: 10,
    height: 10,
    marginRight: 5,
  },
  text:{
    padding: 10,
    width: 400,
    border: "1px solid #ccc",
    flexDirection: "row",
  },
  controleText:{
    padding: 10,
    width: 200,
    border: "1px solid #ccc",
  },
  textVet:{
    fontFamily: "Helvetica-Bold",
    fontWeight: "bold",
  },
  maxbreedte:{
    flexGrow:1,
    border: "1px solid #ccc",
    padding: 10,
  },
  backgroundColor:{
    backgroundColor: "#e0e0e0",
  }
});

const LogistiekPDF = ({
data
}) => {
  // Formatteer de datum naar iets menselijks, bijv. dd/mm/yyyy of dd maand yyyy
  const formattedDate = new Date(data.datum).toLocaleDateString("nl-BE", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <Document>
      <Page size="A4" style={logistiekStyles.page}>
        
        {/* Header: dag, datum, klas, lokaal, leerkracht */}
        <View style={logistiekStyles.table}>
          <View style={[logistiekStyles.tableRow, logistiekStyles.breedte]}>
            <Text style={logistiekStyles.text}>Dag: <Text style={logistiekStyles.textVet}>{data.dag}</Text> </Text>
            <Text style={logistiekStyles.text}>Datum: <Text style={logistiekStyles.textVet}>{formattedDate}</Text></Text>
            <Text style={logistiekStyles.controleText}></Text>
          </View>
          <View style={[logistiekStyles.tableRow, logistiekStyles.breedte]}>
            <Text style={logistiekStyles.text}>Klas: <Text style={logistiekStyles.textVet}>{data.klas}</Text> </Text>
            <Text style={logistiekStyles.text}>Lokaal: <Text style={logistiekStyles.textVet}>{data.lokaal}</Text></Text>
            <Text style={logistiekStyles.controleText}></Text>
          </View>
          <Text style={[logistiekStyles.maxbreedte]}>Gerecht: <Text style={logistiekStyles.textVet}>{data.gerechten.join(", ")}</Text></Text>
          
          <Text style={[logistiekStyles.maxbreedte]}>Leerkracht: <Text style={logistiekStyles.textVet}>{data.leerkracht}</Text></Text>
               
        </View>
        <View style={[logistiekStyles.tableRow, logistiekStyles.breedte, logistiekStyles.backgroundColor]}>
            <Text style={[logistiekStyles.text, logistiekStyles.textVet]}>WAT?</Text>
            <Text style={[logistiekStyles.text, logistiekStyles.textVet]}>HOEVEEL?</Text>
            <Text style={[logistiekStyles.controleText, logistiekStyles.textVet]}>Controle</Text>
          </View>
          
          {data.producten.map((item, index) => (

          <View style={[logistiekStyles.tableRow, logistiekStyles.breedte]}>
            <Text style={[logistiekStyles.text,{backgroundColor: item.kleur, justifyContent: "center" }]}>
              {item.product}
            </Text>

            <Text style={logistiekStyles.text}>{item.aantal}</Text>
            <Text style={logistiekStyles.controleText}></Text>
          </View>
          ))}


        {/* Legende onderaan de PDF */}
        <View style={logistiekStyles.legendContainer}>
          <Text style={[logistiekStyles.legendTitle, logistiekStyles.textVet]}>Legende:</Text>
          {data.legende.map((leg, idx) => (
            <View key={idx} style={logistiekStyles.legendItem}>
              <View style={[logistiekStyles.colorBox, { backgroundColor: leg.kleur }]} />
              <Text>{leg.naam}</Text>
            </View>
          ))}
        </View>
        <View style={styles.daySection}>
      <Text style={styles.classTitle}>Opmerking:</Text>
      <Text >{data.opmerking}</Text>
      </View>
      </Page>
    </Document>
  );
};






// Format date to Dutch locale
const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("nl-BE", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

// Component for MFC PDF
const MfcPdf = ({ mfcData }) => {

  const styles = StyleSheet.create({
    page: {
      padding: 15,
      fontFamily: 'Helvetica',
    },
    title: {
      fontSize: 14,
      marginBottom: 10,
      textAlign: 'center',
      fontWeight: 'bold',
    },
    dayHeader: {
      fontSize: 12,
      marginTop: 8,
      marginBottom: 5,
      fontWeight: 'bold',
      borderBottom: '1px solid #ccc',
      paddingBottom: 2,
    },
    orderContainer: {
      marginBottom: 8,
      padding: 5,
      border: '1px solid #eee',
      borderRadius: 3,
    },
    classHeader: {
      fontSize: 11,
      fontWeight: 'bold',
      marginBottom: 2,
    },
    contentRow: {
      flexDirection: 'row',
      marginTop: 2,
    },
    coursesColumn: {
      width: '75%',
    },
    mfcColumn: {
      width: '25%',
      borderLeft: '1px solid #eee',
      paddingLeft: 5,
    },
    courseItem: {
      marginBottom: 1,
      fontSize: 10,
    },
    mfcItem: {
      fontSize: 10,
      marginBottom: 1,
    }
  });
  return (
    <Document>
    {mfcData.dagen.map((item, index) => (
      <Page size="A4" style={styles.page} key={index}>
        <Text style={styles.title}>
  MFC voor {new Date(mfcData.maand).toLocaleDateString('nl-NL', { month: 'long', year: 'numeric' })}
</Text>

        
        <View>
          <Text style={styles.dayHeader}>Dag: {new Date(item.dag).toLocaleDateString('nl-Nl')}</Text>
          
          {item.bestellingen.map((bestelling, orderIndex) => (
            <View style={styles.orderContainer} key={orderIndex}>
              <Text style={styles.classHeader}>Klas: {bestelling.klasNaam}</Text>
              
              <View style={styles.contentRow}>
                {/* Linker kolom met gerechten */}
                <View style={styles.coursesColumn}>
                  <Text style={styles.courseItem}>
                    Voorgerecht: {bestelling.voorgerecht?.naam
                      ? `${bestelling.voorgerecht.naam} (${bestelling.voorgerecht.aantal})`
                      : "Geen"}
                  </Text>
                  
                  <Text style={styles.courseItem}>
                    Hoofdgerecht: {bestelling.hoofdgerecht?.naam
                      ? `${bestelling.hoofdgerecht.naam} (${bestelling.hoofdgerecht.aantal})`
                      : "Geen"}
                  </Text>
                  
                  <Text style={styles.courseItem}>
                    Nagerecht: {bestelling.nagerecht?.naam
                      ? `${bestelling.nagerecht.naam} (${bestelling.nagerecht.aantal})`
                      : "Geen"}
                  </Text>
                </View>
                
                {/* Rechter kolom met MFC-gegevens */}
                <View style={styles.mfcColumn}>
                  <Text style={styles.mfcItem}>MFC voorgerecht: {bestelling.mfc.aantalVoorgerecht}</Text>
                  <Text style={styles.mfcItem}>MFC Hoofdgerecht: {bestelling.mfc.aantalHoofdgerecht}</Text>
                  <Text style={styles.mfcItem}>MFC Nagerecht: {bestelling.mfc.aantalNagerecht}</Text>
                </View>
              </View>
            </View>
          ))}
        </View>
      </Page>
    ))}
  </Document>
  );
};



const PDFDownloader = {
  generateProductPDF: async (productData, bestandsnaam) => {
    const datum = new Date(productData.datum).toLocaleDateString("nl-BE", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })
    const blob = await pdf(<ProductPDF productData={productData} />).toBlob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${bestandsnaam}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },

  generateVleesPDF: async (vleesData, bestandsnaam) => {
    
  
    const datum = new Date(vleesData.datum).toLocaleDateString("nl-BE", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })
    const blob = await pdf(<VleesPDF vleesData={vleesData} />).toBlob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${bestandsnaam}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  generateLogistiekPDF: async (logistiekData, bestandsnaam) => {
    const datum = new Date(logistiekData.datum).toLocaleDateString("nl-BE", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })
    const blob = await pdf(<LogistiekPDF data={logistiekData} />).toBlob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${bestandsnaam}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },

  generateMfcPDF: async (mfcData) =>{
    const datum = new Date().toLocaleDateString("nl-BE", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })
    const blob = await pdf(<MfcPdf mfcData={mfcData} />).toBlob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `mfc-${mfcData.maand}-${datum}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  
};

export default PDFDownloader;
